module.exports = __webpack_public_path__ + "img/favorite.940774b6.svg";